












import { defineComponent } from '@vue/composition-api';
import { useAutoPlay } from './useAutoPlay';
// @ts-ignore
import spSwitch from '@ks/sharp-ui/lib/switch';
import '@ks/sharp-ui/lib/themes/default/switch.css';

export default defineComponent({
    components: {
        spSwitch,
    },
    model: {
        prop: 'autoPlay',
        event: 'change',
    },
    setup(props, { emit }) {
        function changeValue(val: unknown): void {
            emit('change', val as boolean);
        }
        const { curAutoPlay } = useAutoPlay(changeValue);
        return {
            curAutoPlay,
        };
    },
});
